// extracted by mini-css-extract-plugin
export var button = "_ce-4";
export var hasDarkBackground = "_ce-7";
export var hasLightBackground = "_ce-6";
export var iconWrapper = "_ce-0";
export var large = "_ce-2";
export var medium = "_ce-1";
export var small = "_ce-5";
export var xsmall = "_ce-3";